import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import ProsserContent from "./ProsserPumpContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route path="/suppliers/prosser/pumps" component={ProsserContent} />
          <Route path="/suppliers/prosser">
            <Redirect to="/suppliers/prosser/pumps" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
